<template>
  <section class="favorite_users">
    <div class="favorite_users_content">
      <div class="favorite_users_content__center">
        <div class="favorite_users_header">
          <h2>{{ getTranslations.home_users_favorite_users_title }}</h2>
          <p>{{ getTranslations.home_users_favorite_users_invite_text1 }}
            {{ numberFormatting(inviteConfig.invitePoints) }}
            {{ getTranslations.home_users_favorite_users_invite_text2 }}
          </p>
          <div class="invite_btn">
            <a href="#"
               @click.prevent="inviteFriends()"
               class="btn2 btn--v2 btn2--medium btn2--green">
              {{ getTranslations.home_users_favorite_users_invite }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <fade-transition>
      <invite-friend v-if="showInvitation" @close="showInvitation = false"/>
    </fade-transition>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import InviteFriend from '@/components/home/modals/users/InviteFriend';
import FadeTransition from '@/components/home/modals/shared/FadeTransition';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';

export default {
  name: 'Invitation',
  mixins: [NumbersFormattingMixin],
  components: {
    InviteFriend,
    FadeTransition,
  },
  data() {
    return {
      showInvitation: false,
    };
  },
  methods: {
    inviteFriends() {
      this.showInvitation = true;
    },
  },
  computed: {
    ...mapState('common', [
      'inviteConfig',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/users/Invitation.vue